class VariantSelect extends HTMLElement {
    variantCache;
    form;
    variants;

    constructor() {
        super();

        this.variantCache = {};
        this.form = this.querySelector("form");
        this.variants = JSON.parse(
            this.querySelector('[js-product-form="data"]').innerHTML,
        );
    }

    connectedCallback() {
        this.setEventListeners();
    }

    setEventListeners() {
        this.form.addEventListener("change", this.handleChange.bind(this));

        const labels = this.querySelectorAll(".variant-select__variant");
        labels.forEach((label) => {
            label.addEventListener("keydown", this.handleKeyDown.bind(this));
        });
    }

    handleKeyDown(event) {
        const keyEvent = event;
        if (keyEvent.key === " " || keyEvent.key === "Enter") {
            event.preventDefault();

            const label = event.target;
            const input = label.querySelector(
                'input[type="radio"]',
            );

            if (input) {
                input.checked = true;

                const changeEvent = new Event("change", { bubbles: true });
                input.dispatchEvent(changeEvent);
            }
        }
    }

    async handleChange(event) {
        if (!(event.target instanceof HTMLInputElement)) {
            return;
        }

        const productForm = document.querySelector("uw-product-form");

        if (productForm) {
            productForm.classList.add("is-loading");
        }

        const { variants, variantCache } = this;
        const form = event.target.form;
        const selectedOptionValues = [...new FormData(form).entries()];

        const selectedVariant = variants.find(
            (variant) =>
                selectedOptionValues.every(
                    ([optionName, value]) =>
                        variant[optionName] === value,
                ),
        );

        const firstAvailableVariant = variants.find((variant) => variant.available);

        const selectedOrFirstAvailableVariant =
            selectedVariant ?? firstAvailableVariant ?? variants[0];

        const query = new URLSearchParams(window.location.search);
        const variantId = selectedOrFirstAvailableVariant.id;

        query.set("variant", variantId.toString());
        query.set("sections", this.getAttribute("data-section-id"));

        const response = variantCache[variantId]
            ? variantCache[variantId]
            : await fetch(`${window.location.pathname}?${query}`).then(async (r) => ({
                sections: await r.json(),
                id: variantId,
                variant: selectedOrFirstAvailableVariant,
            }));

        variantCache[variantId] = response;

        sessionStorage.setItem(
            "henchman-variant-cache",
            JSON.stringify(variantCache),
        );

        this.variantCache[variantId] = response;

        document.dispatchEvent(
            new CustomEvent("variant:update", { detail: response }),
        );

        document
            .querySelector('[js-product-details="error"]')
            ?.classList.add("is-hidden");

        const sectionId = this.getAttribute("data-section-id");

        const newHtml = new DOMParser()
            .parseFromString(response.sections[sectionId], "text/html")
            .querySelector(this.tagName.toLowerCase());

        if (!newHtml) {
            console.error("Could not find new HTML");
            return;
        }

        this.innerHTML = newHtml.innerHTML;

        this.form = this.querySelector("form");
        this.variants = JSON.parse(
            this.querySelector('[js-product-form="data"]').innerHTML,
        );

        this.setEventListeners();
    }
}

customElements.define("uwp-variant-select", VariantSelect);